import { t } from 'i18next'
import { Fragment } from 'react'

interface IProps {
  dataSource: any[]
  loading?: boolean
  mobileListRender?: (item: any, index: number) => React.ReactNode
}

const ListView = ({ dataSource, loading, mobileListRender }: IProps) => {
  if (loading)
    return (
      <div className="skeleton-container mt-3">
        <div className="skeleton-placeholder skeleton-title"></div>
        <div className="skeleton-placeholder skeleton-content"></div>
        <div className="skeleton-placeholder skeleton-content"></div>
        <div className="skeleton-placeholder skeleton-content"></div>
      </div>
    )

  if (!dataSource?.length)
    return <div className="text-center py-6 text-color-secondary">{t('No available options')}</div>

  return (
    <div className="flex flex-column gap-3 mt-3">
      {dataSource.map((item, index) => (
        <Fragment key={item?._id ?? index}>{mobileListRender?.(item, index)}</Fragment>
      ))}
    </div>
  )
}

export default ListView
